export default __webpack_public_path__ + "static/media/logo-mandiri.2a9563f3.jpg";